import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance } from 'vue'
import { Organization } from '@/modules/Organizations/types'
import { useImage } from '@/shared/composables/image'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationAbout',
  props: {
    org: null
  },
  setup(__props: any) {

const props = __props as {
  org: Organization
};

const { getAvatar } = useImage()


const instance = getCurrentInstance()

return { __sfc: true,getAvatar, props, instance }
}

})